export const brand = {
  name: "KinesLima",
  tagline: "Lencería que celebra tu estilo",
  email: "hola@kineslima.pe",
  phone: "+51 900 123 456",
  whatsapp: "51900123456",
  instagram: "@kineslima.pe",
  colors: {
    background: "#0B0710",
    surface: "#140D18",
    card: "#1B1120",
    border: "#35223D",
    primary: "#EC1970",
    primaryHover: "#D71564",
    secondary: "#A855F7",
  },
} as const;
